import { render, staticRenderFns } from "./LoadingBar.vue?vue&type=template&id=4c7e6d70&scoped=true&"
import script from "./LoadingBar.vue?vue&type=script&lang=js&"
export * from "./LoadingBar.vue?vue&type=script&lang=js&"
import style0 from "./LoadingBar.vue?vue&type=style&index=0&id=4c7e6d70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7e6d70",
  null
  
)

export default component.exports